"use strict";
/**
 * Performance optimized version of `Array.prototype.forEach` method.
 *
 * Executes a provided function once for each array element.
 * @see https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Array/forEach
 *
 * **Limitations against native implementation**:
 *
 * - **`callback` is invoked for all indexes of the array**,
 * (not only for indexes with assigned values like native filter implementation), see example.
 * - Doesn't accept the scope as last argument.
 *
 * @param {Array} array - Input array.
 * @param {Function} callback - Function to execute on each element.
 *
 * @return {void}
 *
 * @example
 * import { forEach } from '@24i/appstage-shared-perf-utils/dist/array';
 *
 * const array = ['a', 'b', 'c'];
 *
 * // array.forEach(item => console.log(item)); // slower native solution
 * forEach(array, item => console.log(item));   // faster
 *
 * // expected output: "a"
 * // expected output: "b"
 * // expected output: "c"
 *
 * @example
 * import { forEach } from '@24i/appstage-shared-perf-utils/dist/array';
 *
 * const array = new Array(1000); // creates an empty array with length 1000
 *
 * let iNative = 0;
 * array.forEach(() => iNative++);
 * console.log(iNative); // 0 - the callback was never called
 *
 * let iCustom = 0;
 * forEach(array, () => iCustom++);
 * console.log(iCustom); // 1000 - the callback was called for each item (hole) in array
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.forEach = void 0;
const forEach = (array, callback) => {
    for (let i = 0, len = array.length; i < len; i++) {
        callback(array[i], i, array);
    }
};
exports.forEach = forEach;
